// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ForeignContentNotification_wrapper__off0w","message":"ForeignContentNotification_message__CRRne","link":"ForeignContentNotification_link__EvJTj"};